export default __webpack_public_path__ + "static/media/js.e9e5ff42.png";